<template>
  <div class="saml-account-chooser">
    <p class="_body">
      {{ $t('samlChooseAccount.body', { email }) }}
    </p>
    <div class="_accounts">
      <sign-in-account-row
        v-for="candidate in candidates"
        :key="candidate.slug"
        :name="candidate.companyName || candidate.slug"
        :loading="loadingSlug === candidate.slug"
        @select="emit('select', candidate.slug)"
      />
    </div>
  </div>
</template>

<script setup>
import SignInAccountRow from '@/components/SignInAccountRow.vue';

defineProps({
  candidates: {
    type: Array,
    required: true,
  },
  email: {
    type: String,
    default: '',
  },
  loadingSlug: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['select']);
</script>

<style scoped lang="scss" type="text/scss">
  .saml-account-chooser {
    ._body {
      margin: 0 0 2rem;
      color: $font-color-secondary;
      font-size: $font-size-4;
      line-height: 1.55;
    }

    ._accounts {
      display: flex;
      flex-direction: column;
      gap: 1.2rem;
    }
  }
</style>
